/* eslint-disable react/require-default-props */
/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import React, {
  useEffect, useContext, useMemo, useState,
} from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';

import { DorForecastItem, PrimaryCarousel, WysiwygStyleWrapper } from '@powdr/components';
import { CarouselControlPlacement, ForecastLengths } from '@powdr/constants';
import { AppContext } from '@powdr/context';
import { getWeather } from '@powdr/stores';

import {
  StyledDorWeather,
  StaticHeader,
  OpenWeatherAttribution,
  ForecastList,
  ForecastListItem,
} from './styles';

export const DorWeather = ({
  title = null,
  html = null,
  isParentNavFeed = false,
  descriptionLength = null,
  parentColorProfile = null,
  maxItems = null,
}) => {
  const dispatch = useDispatch();
  const useWeatherData = useSelector((state) => state.weather);
  const { data: weather } = useWeatherData;
  const { isMobile } = useContext(AppContext);
  const [forecast, setForecast] = useState([]);

  useEffect(() => {
    dispatch(getWeather());
  }, [dispatch]);

  useEffect(() => {
    if (weather?.forecast && Array.isArray(weather?.forecast)) {
      setForecast((maxItems !== null && maxItems < weather?.forecast.length)
        ? weather.forecast.slice(0, maxItems)
        : weather.forecast);
    }
  }, [maxItems, weather, setForecast]);

  const ForecastMap = useMemo(
    () => forecast?.map((day) => (
      <ForecastListItem key={day.id}>
        <DorForecastItem
          icon={day?.weather_icon}
          temperature={{
            min: day?.temperature_low,
            max: day?.temperature_high,
          }}
          snowfall={{
            min: 0,
            max: 0,
          }}
          date={day?.day}
          description={(day?.description_long && descriptionLength === ForecastLengths.LONG)
            ? day.description_long
            : day?.description_short || null}
          isFitToContent={isParentNavFeed || isMobile}
        />

      </ForecastListItem>
    ) || []),
    [isParentNavFeed, forecast, isMobile, descriptionLength],
  );

  return (
    <StyledDorWeather
      colorProfile={parentColorProfile}
      isParentNavFeed={isParentNavFeed}
    >
      <>
        {(!isParentNavFeed && (title || html)) && (
          <StaticHeader>
            {title && (<h3>{title}</h3>)}
            {html && (
              <WysiwygStyleWrapper colorProfile={parentColorProfile}>
                {ReactHtmlParser(html)}
              </WysiwygStyleWrapper>
            )}
          </StaticHeader>
        )}
        {weather?.attribution && (
          <OpenWeatherAttribution aria-label="Powered By OpenSnow" href={weather?.attribution?.link_url}>
            Powered By:
            <img src={weather?.attribution?.image_light_url} alt="" />
          </OpenWeatherAttribution>
        )}
        <ForecastList>
          {isParentNavFeed || isMobile ? (
            <PrimaryCarousel
              controlSettings={{
                navigation: {
                  iconName: 'ui-arrow-left',
                  size: 30,
                  placement: CarouselControlPlacement.IN_WRAPPER,
                },
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                960: {
                  slidesPerView: 2,
                },
                1366: {
                  slidesPerView: 3,
                },
              }}
              isInfiniteScroll={false}
              colorProfile={parentColorProfile}
            >
              {ForecastMap}
            </PrimaryCarousel>
          ) : (
            <PrimaryCarousel
              isInfiniteScroll={false}
              slidesPerView="auto"
              fitSlideWidthToItem
              controlSettings={{
                scrollbar: {
                  placement: CarouselControlPlacement.BOTTOM,
                },
              }}
              spaceBetweenSlides={30}
              colorProfile={parentColorProfile}
            >
              {ForecastMap}
            </PrimaryCarousel>
          )}
        </ForecastList>
      </>
    </StyledDorWeather>
  );
};

DorWeather.propTypes = {
  title: PropTypes.string,
  html: PropTypes.string,
  isParentNavFeed: PropTypes.bool,
  descriptionLength: PropTypes.string,
  parentColorProfile: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  maxItems: PropTypes.number,
};
